


import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { AuthenticationService } from 'synergy-core';
declare var $: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent implements OnInit {


  title = 'XmartBusiness';
  organizationId!: number;
  branchId!: number;

  constructor(public authenticationService: AuthenticationService,
    private confirmationService: ConfirmationService,
    private router: Router) { }

  ngOnInit() {



  }


  onLogOut() {

    this.confirmationService.confirm({
      message: 'Desea realmente salir de la aplicacion?',
      header: 'Confirmacion',
      icon: 'pi pi-exclamation-triangle',
      key: 'main',
      accept: () => {
        this.authenticationService.logOut();
        this.router.navigate(['/Login']);
      },
      reject: () => {
      }
    });
  }

}

